export default __webpack_public_path__ + "static/media/ic-practice.4210a39e.svg";